import moment from 'moment';

export default {
  methods: {
    formatDateTime(date, format = 'YYYY-MM-DD') {
      if (!date) {
        return '';
      }

      return moment(date).format(format);
    }
  }
};

export const DateTimeFormatter = () => {
  const formatDateTime = (date, format = 'YYYY-MM-DD') => {
    if (!date) {
      return '';
    }

    return moment(date).format(format);
  };

  return {
    formatDateTime,
  };
};
